import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import {User} from '../../models/user.model';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  currentUser:User;
  logoutUrl:string;
  loginUrl:string;
  constructor(protected localStorage: LocalStorage,private authUser: AuthUserService,private cookieService: CookieService) { }

  ngOnInit() {
    
    this.currentUser = this.authUser._user;
    this.logoutUrl = environment.logoutUrl;
    this.loginUrl = environment.loginUrl;

  }

  onNavigation() {
    // clear local storage items
    this.localStorage.clear().subscribe(() => {});
    this.cookieService.set('AuthTrackerCookie','',-1,'/');
    

  }
}



// WEBPACK FOOTER //
// ./src/app/layout/navbar/navbar.component.ts